import React from 'react'
import Text from '../../../../components/Text'
import Lottie from 'react-lottie'
import warningIcon from '../../../../assets/icons/warning.svg'

const DocumentStatusBanner = ({
  hasRejectedDocuments,
  coinsCount,
  coinsAnimationOptions,
}) => {
  return (
    <div className="space-y-3">
      {hasRejectedDocuments ? (
        <div className="bg-[#FEF3F2] px-4 py-3 flex items-start gap-2 rounded-lg">
          <img src={warningIcon} alt="Warning" className="w-8 h-8" />
          <Text tag="p" variant="body" size="large" className="text-[#B42318]">
            There seems to be some problem with the document(s). Please
            re-upload.
          </Text>
        </div>
      ) : (
        <div className="bg-[#D9C4EE] px-4 py-3 flex items-start gap-2">
          <div className="min-w-12">
            <Lottie speed={0.7} options={coinsAnimationOptions} width={45} />
          </div>
          <Text tag="p" variant="body" size="large" className="text-[#1F2933]">
            Your documents are under review. You will receive{' '}
            <b>{coinsCount} care coins</b> after approval.
          </Text>
        </div>
      )}
    </div>
  )
}

export default DocumentStatusBanner
